const SUBSTANCE_CLAIM_OPTIONS = Object.freeze([
    'substances_above_threshold',
    'substances_below_threshold',
    'does_not_contain_restricted_substances',
])

const MANAGED_SUBSTANCE_CLAIMS = Object.freeze([
    ...SUBSTANCE_CLAIM_OPTIONS,
    'no_substances_above_threshold',
    'contains_restricted_substances',
])

const ADDABLE_SUBSTANCE_CLAIMS = Object.freeze(SUBSTANCE_CLAIM_OPTIONS.slice(0, 2))

export {
    ADDABLE_SUBSTANCE_CLAIMS,
    MANAGED_SUBSTANCE_CLAIMS,
    SUBSTANCE_CLAIM_OPTIONS,
}
